import React, { useEffect, useRef } from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';
import VideoCarousel from './VideoCarousel';
import VideoSlider from './VideoSlider';

const videos = [
  { src: process.env.PUBLIC_URL + '/videos/video1.mp4', title: 'TE(x)US L∆B', subtitle: "Welcome!", thirdtext:"Texas Extreme Weather and Urban Sustainability Lab" },
  { src: process.env.PUBLIC_URL + '/videos/title_video-2.mp4', thirdtext: ' We study weather extremes and cities.' },
  { src: process.env.PUBLIC_URL + '/videos/title_video-4.mp4', thirdtext: ' Our goal is to be at the forefront of urban & extreme weather research and to make our science useful and useable' },
  { src: process.env.PUBLIC_URL + '/videos/Austin-2.mp4', thirdtext: 'We are a part of the Jackson School of Geosciences  at The University of Texas at Austin',logo: process.env.PUBLIC_URL + '/images/knockout_university_primary.png'  },
  // Add more video sources as needed
];

function HeroSection() {
  const containerRef = useRef(null);

  /* Hands the hero off to the page: as it leaves, the footage settles back
     and fades rather than simply sliding away. Written to a custom property
     so the styling stays in CSS, and skipped entirely under reduced motion. */
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return undefined;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;

    let ticking = false;

    const update = () => {
      ticking = false;
      const height = el.offsetHeight || 1;
      const progress = Math.min(Math.max(window.scrollY / height, 0), 1);
      el.style.setProperty('--hero-exit', progress.toFixed(3));
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  const scrollToNextSection = () => {
    const introductionSection = document.querySelector('.intro-container');
    if (introductionSection) {
      introductionSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <div className="hero-container" ref={containerRef}>
      
      <div className="hero-slider">
        <VideoSlider  videos={videos} />
      </div>
      

      
      <div className="scroll-arrow" onClick={scrollToNextSection}>
        <div className="arrow-down"></div>
      </div>
    </div>
  );
}


export default HeroSection;
